import { classifierColumns, classifierSchema } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
import { z } from 'zod';
export const missionPositionEntityName = 'missionPosition';
export const missionPositionSchema = classifierSchema.extend({
    groupIds: z.string().uuid().array().optional(),
    occupationIds: z.string().uuid().array().optional(),
    allOccupations: z.boolean().optional(),
    description: z.string().optional(),
    ecl: z.string().trim().min(1).array().optional(),
    skillIds: z.string().uuid().array().optional(),
    trainingIds: z.string().uuid().array().optional(),
    trainCourseIds: z.string().uuid().array().optional(),
    languageIds: z.string().uuid().array().optional(),
    state: z.string().optional(),
    residenceType: z.enum(['county', 'tribe']).optional(),
    counties: z.string().trim().min(1).array().optional(),
    tribeIds: z.string().uuid().array().optional(),
    deploymentDurationId: z.string().uuid().optional(),
    deploymentDurationLength: z.number().optional(),
    deploymentTravelWillingnessIds: z.string().uuid().array().optional(),
    federalDeploymentWillingness: z.boolean().optional(),
    priorCommitments: z.boolean().optional(),
});
export const missionPositionColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { allOccupations: {
        type: 'boolean',
    }, search: {
        type: 'full-text-search-required',
        language: 'english',
    }, occupationIds: {
        type: 'id-array',
    }, groupIds: {
        type: 'id-array',
    }, ecl: {
        type: 'string-array',
    }, skillIds: {
        type: 'id-array',
    }, trainingIds: {
        type: 'id-array',
    }, languageIds: {
        type: 'id-array',
    }, state: {
        type: 'string',
    }, residenceType: {
        type: 'string',
    }, tribeIds: {
        type: 'id-array',
    }, counties: {
        type: 'string-array',
    }, deploymentTravelWillingnessIds: {
        type: 'id-array',
    }, deploymentDurationLength: {
        type: 'number',
    }, federalDeploymentWillingness: {
        type: 'boolean',
    }, priorCommitments: {
        type: 'boolean',
    }, trainCourseIds: {
        type: 'id-array',
    } }));
